import { __assign } from "tslib";
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { R50 } from '@atlaskit/theme/colors';
import { Frame } from '../components/Frame';
import { Thumbnail } from '../components/Thumbnail';
import { Provider } from '../components/Provider';
import { Name } from '../components/Name';
import { Byline } from '../components/Byline';
import { ActionList } from '../components/ActionList';
import { Content } from '../components/Content';
import { LockImage } from '../utils/constants';
var containerStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
};
export var ForbiddenView = function (_a) {
    var _b = _a.context, context = _b === void 0 ? { text: '' } : _b, byline = _a.byline, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, _d = _a.actions, actions = _d === void 0 ? [] : _d, testId = _a.testId;
    return (jsx(Frame, { isSelected: isSelected, testId: testId },
        jsx(Content, null,
            jsx("div", null,
                jsx(Name, { name: "You don't have access to this link", isLeftPadded: false, testId: testId ? testId + "-name" : undefined }),
                jsx(Byline, __assign({}, byline))),
            jsx("div", { css: containerStyles },
                jsx(Provider, { name: context.text, iconUrl: context.icon }),
                jsx(ActionList, { items: actions }))),
        jsx(Thumbnail, { testId: testId ? testId + "-thumb" : undefined, src: LockImage, color: R50 })));
};
//# sourceMappingURL=ForbiddenView.js.map